import { yupResolver } from '@hookform/resolvers/yup';
import { Button, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom'
import { userSaas } from '../validations/Validation';
import { toast } from 'react-toastify';
import { postSAAS } from '../services/post.service';
import { getBranchCount, getOwnerCount } from '../services/get.service';
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import ClipLoader from 'react-spinners/ClipLoader';

interface SAASForm {
    email: string;
    name: string;
    firstName: string;
    middleName: string;
    lastName: string;
    password: string;
    confirmPassword: string;
    phoneNumber: string;
    pic_url: File;
}

const Front = () => {
  const { register, handleSubmit, formState: { errors } } = useForm<SAASForm>({
          resolver: yupResolver(userSaas),
      })
  const [loading, setLoading] = useState(false)
  const [loading2, setLoading2] = useState(false)
  const [loading3, setLoading3] = useState(false)
  const navigate = useNavigate()
  const [ownerCount, setOwnerCount] = useState<number>(0)
  const [branchCount, setBranchCount] = useState<number>(0)
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

  useEffect(() => {
    setLoading2(true)
    setLoading3(true)
    getOwnerCount()
      .then((res) => {setLoading2(false); setOwnerCount(res.data)})
      .catch((err) => { setLoading2(false); console.log(err)});
    getBranchCount()
    .then((res) => {setLoading3(false); setBranchCount(res.data)})
    .catch((err) => { setLoading3(false); console.log(err)});
  }, [])

  const onSubmit = (data: any) => {
    setLoading(true)
    const loading = toast.loading("Please wait...", {
        theme: "colored",
        type: "info",
        closeButton: true,
    })

    var formData = new FormData()
    
    formData.append("name", data.name)
    formData.append("firstName", data.firstName)
    formData.append("middleName", data.middleName)
    formData.append("lastName", data.lastName)
    formData.append("email", data.email)
    formData.append("password", data.password)
    formData.append("phoneNumber", data.phoneNumber)
    formData.append("confirmPassword", data.confirmPassword)
    if(data.pic_url.length > 0)
        formData.append("pic_url", data.pic_url[0])

    postSAAS(formData)
        .then((res) => {
            toast.update(loading, {
                render: res.data,
                type: "success",
                theme: "colored",
                autoClose: 2500,
                isLoading: false,
                closeOnClick: true,
                hideProgressBar: false,
            });
            setLoading(false);
            navigate("/login");
        })
        .catch((err) => {
            toast.update(loading, {
                render: err?.response?.data || "Some Error happened",
                theme: "colored",
                autoClose: 5000,
                type: "error",
                isLoading: false,
                closeOnClick: true,
                hideProgressBar: false,
            });
            setLoading(false);
            console.log(err);
        })
      }
      
  return (
    <div className='w-full bg-indigo-300'>
      <div id='welcome' className='bg-gradient-to-r from-blue-200 to-red-200 border-5 p-10 lg:p-40'>
        <div className='text-center text-5xl font-bold animate-pulse'>
          Welcome to Your Dental Clinic Simplified System
        </div>
      </div>
      <div id='features' className='text-center text-4xl pt-10 pb-5'>
        System Features
      </div>
      <div className='grid lg:grid-cols-2 grid-cols-1 lg:gap-10 gap-3 mx-5 lg:mx-20 pb-5'>
        <div className='bg-gradient-to-r from-red-200 to-green-200 rounded-lg drop-shadow-xl'>
          <div className='text-center font-bold pt-2'>
            Registration
          </div>
          <ul className='list-disc mx-10 lg:mx-20 grid grid-cols-2 py-3'>
            <li>Patient</li>
            <li>Payment</li>
            <li>Staff</li>
            <li>User</li>
            <li>Treatments</li>
            <li>Branches</li>
          </ul>
        </div>
        <div className='bg-gradient-to-r from-red-200 to-green-200 rounded-lg drop-shadow-xl'>
          <div className='text-center font-bold pt-2'>
            Payment Filter
          </div>
          <p className='indent-3 mx-5 py-3'>
            All Payments can be retrieved according to your filter criteria of
            <ul className='list-disc mx-10 lg:mx-20 grid grid-cols-2 py-3'>
              <li>Patients</li>
              <li>Date</li>
              <li>Branch</li>
              <li>Cashier</li>
              <li>Treatment</li>
            </ul>
          </p>
        </div>
        <div className='bg-gradient-to-r from-red-200 to-green-200 rounded-lg drop-shadow-xl'>
          <div className='text-center font-bold pt-2'>
            Appointments
          </div>
          <p className='indent-3 mx-5 py-3'>
            The system will help you to get every patient possible appointments.
          </p>
        </div>
        <div className='bg-gradient-to-r from-red-200 to-green-200 rounded-lg drop-shadow-xl'>
          <div className='text-center font-bold pt-2'>
            Treatments
          </div>
          <p className='indent-3 mx-5 py-3'>
            You can register existing and new treatments with payment range.
          </p>
        </div>
        <div className='bg-gradient-to-r from-red-200 to-green-200 rounded-lg drop-shadow-xl'>
          <div className='text-center font-bold pt-2'>
            Patient Search
          </div>
          <p className='indent-3 mx-5 py-3'>
            You can search patients with their cardNo or PhoneNo easily, And also fetch all registered patients.
          </p>
        </div>
        <div className='bg-gradient-to-r from-red-200 to-green-200 rounded-lg drop-shadow-xl'>
          <div className='text-center font-bold pt-2'>
            Payment Tracking
          </div>
          <p className='indent-3 mx-5 py-3'>
            Every payment made by a patient will be recorded. This will be very usefull 
            for a patient who pays with schedule to track the remainings.
          </p>
        </div>
      </div>
      <div className='text-center lg:text-4xl text-2xl font-serif pt-10 mx-5 lg:mx-20 bg-gradient-to-r from-purple-300 to-yellow-100 rounded-lg drop-shadow-xl p-5'>
        Now We're working with <span className='font-bold'>{loading2 ? <ClipLoader size={15} /> : ownerCount}</span> dental clinics and <span className='font-bold'>{loading3 ? <ClipLoader size={15} /> : branchCount}</span> branches to simplify their daily activities.
      </div>
      <div className='text-center text-4xl pt-10 pb-5'>
        So, What are you waiting?
      </div>
      <div className='pb-10 drop-shadow-xl'>
        <div id='signup' className='bg-indigo-200 mx-10 lg:mx-60 m-30 lg:m-50 pb-10 rounded-xl'>
          <div className='text-center text-lg font-bold font-italic pt-3'>Sign up here</div>
          <form className='mx-10 lg:mx-20 grid grid-cols-1 gap-3 pt-3' onSubmit={handleSubmit(onSubmit)}>
            <div>
                <TextField size="small" fullWidth label="Your Dental Clinic Name" {...register("name")} error={errors.name ? true : false} />
                <p color="error" className="text-red-700 text-sm">{errors.name?.message}</p>
            </div>
            <div>
                <TextField size="small" fullWidth label="Logo" type="file" {...register("pic_url")} error={errors.pic_url ? true : false} />
                <p color="error" className="text-red-700 text-sm">{errors.pic_url?.message}</p>
            </div>
            <div>
                <TextField size="small" fullWidth label="First Name" {...register("firstName")} error={errors.firstName ? true : false} />
                <p color="error" className="text-red-700 text-sm">{errors.firstName?.message}</p>
            </div>
            <div>
                <TextField size="small" fullWidth label="Middle Name" {...register("middleName")} error={errors.middleName ? true : false} />
                <p color="error" className="text-red-700 text-sm">{errors.middleName?.message}</p>
            </div>
            <div>
                <TextField size="small" fullWidth label="Last Name" {...register("lastName")} error={errors.lastName ? true : false} />
                <p color="error" className="text-red-700 text-sm">{errors.lastName?.message}</p>
            </div>
            <div>
                <TextField size="small" fullWidth label="Email" type="email" {...register("email")} error={errors.email ? true : false} />
                <p color="error" className="text-red-700 text-sm">{errors.email?.message}</p>
            </div>
            <div>
                <TextField size="small" fullWidth label="Phone Number" {...register("phoneNumber")} error={errors.phoneNumber ? true : false} />
                <p color="error" className="text-red-700 text-sm">{errors.phoneNumber?.message}</p>
            </div>
            <div>
                <div className='inline flex w-full items-center relative'>
                  <TextField size="small" fullWidth label="Password" type={showPassword ? "text" : "password"}
                    {...register("password")} error={errors.password ? true : false} />
                  {showPassword ?
                    <VisibilityOffOutlined className='absolute right-3 cursor-pointer' onClick={() => setShowPassword(false)} />
                    :
                    <VisibilityOutlined className='absolute right-3 cursor-pointer' onClick={() => setShowPassword(true)} />
                  }
                </div>
                <p color="error" className="text-red-700 text-sm">{errors.password?.message}</p>
            </div>
            <div>
                <div className='inline flex w-full items-center relative'>
                  <TextField size="small" fullWidth label="Confirm Password" type={showConfirmPassword ? "text" : "password"}
                  {...register("confirmPassword")} error={errors.confirmPassword ? true : false} />
                  {showConfirmPassword ?
                    <VisibilityOffOutlined className='absolute right-3 cursor-pointer' onClick={() => setShowConfirmPassword(false)} />
                    :
                    <VisibilityOutlined className='absolute right-3 cursor-pointer' onClick={() => setShowConfirmPassword(true)} />
                  }
                </div>
                <p color="error" className="text-red-700 text-sm">{errors.confirmPassword?.message}</p>
            </div>
            <Button variant='contained' disabled={loading} type="submit">Sign Up Your Dental Clinic</Button>
            <span className='text-center text-sm'>Already had an account <Link to={'/login'} className='text-blue-700'>Sign In</Link></span>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Front